<template>
    <div class="signal-container" v-cloak>
        <div class="content-wrapper">
            <div class="flex">
                <div class="flex flex-col">
                    <figure>
                        <img :src="imagePath('bus')" class="bus">
                        <img :src="imagePath('cloud-refresh')" class="bus2">
                        <figcaption>{{ $t('signalstore.graphic_1') }}</figcaption>
                    </figure>
                </div>

                <div class="flex arrow single">
                    <img :src="imagePath('Component 53 – 1')">
                </div>

                <div class="flex flex-col rest-container" @click="showRealtime = true">
                    <div class="figure-wrapper">
                        <figure class="rest-figure">
                            <img :src="imagePath('server-rack')">
                            <figcaption v-html="$t('signalstore.graphic_2')"></figcaption>
                        </figure>
                        <figure class="rest-figure">
                            <img :src="imagePath('server-rack')">
                            <figcaption v-html="$t('signalstore.graphic_3')"></figcaption>
                        </figure>
                    </div>

                    {{ $t('signalstore.graphic_4') }}
                </div>

                <div class="flex arrow group">
                    <img :src="imagePath('Group 1232')">
                </div>

                <div class="flex flex-col" style="margin-right:30px;">
                    <figure @click="showRfms = true" style="cursor: pointer; margin-top: 15px;">
                        <img :src="imagePath('Group 1219')">
                        <figcaption>{{ $t('signalstore.graphic_5') }}</figcaption>
                    </figure>

                    <figure @click="showPlus = true" style="cursor: pointer; margin-top: 15px;">
                        <img :src="imagePath('Group 1219')">
                        <figcaption>{{ $t('signalstore.graphic_6') }}</figcaption>
                    </figure>

                    <figure @click="showDiag = true" style="cursor: pointer; margin-top: 15px;"> 
                        <img :src="imagePath('Group 1218')">
                        <figcaption>{{ $t('signalstore.graphic_7') }}</figcaption>
                    </figure>
                </div>

                <div class="flex arrow single">
                    <img :src="imagePath('Component 53 – 1')">
                </div>

                <div class="flex" style="margin-top: 50px;">
                    <figure>
                        <img :src="imagePath('API')">
                        <figcaption>{{ $t('signalstore.graphic_8') }}</figcaption>
                    </figure>
                </div>
            </div>
        </div>

        <sidebar style="top: 245px;" :backbutton="'backbutton-grey'">
            <h3>{{ $t('signalstore.nav_header') }}</h3>

            <ul>
                <li @click="showRfms = true" style="cursor: pointer;">{{ $t('signalstore.nav_1') }}</li>
                <li @click="showPlus = true" style="cursor: pointer;">{{ $t('signalstore.nav_2') }}</li>
                <li @click="showDiag = true" style="cursor: pointer;">{{ $t('signalstore.nav_3') }}</li>
            </ul>
        </sidebar>

        <overlay id="data-package-rfms" :image="'bus-warbe-rfms'" :satelite="'satelite'" v-if="showRfms" @close="closeRfms">
            <div slot="content">
                <h3>{{ $t('signalstore.modal_rfms_header') }}</h3>
                <p>
                    <ul>
                        <li>{{ $t('signalstore.modal_rfms_copy_1') }}</li>
                        <li>{{ $t('signalstore.modal_rfms_copy_2') }}</li>
                        <li>{{ $t('signalstore.modal_rfms_copy_3') }}</li>
                        <li>{{ $t('signalstore.modal_rfms_copy_4') }}</li>
                        <li>{{ $t('signalstore.modal_rfms_copy_5') }}</li>
                    </ul>
                </p>
            </div>

            <div slot="info">
                <p v-html="$t('signalstore.modal_rfms_info')"></p>
            </div>
        </overlay>

        <overlay id="data-package-plus" :image="'bus-warbe-plus'" :satelite="'satelite'" v-if="showPlus" @close="closePlus">
            <div slot="content">
                <h3>{{ $t('signalstore.modal_plus_header') }}</h3>
                <p>
                    <ul>
                        <li>{{ $t('signalstore.modal_plus_copy_1') }}</li>
                        <li>{{ $t('signalstore.modal_plus_copy_2') }}</li>
                        <li>{{ $t('signalstore.modal_plus_copy_3') }}</li>
                        <li>{{ $t('signalstore.modal_plus_copy_4') }}</li>
                    </ul>
                </p>
            </div>

            <div slot="info">
                <p v-html="$t('signalstore.modal_plus_info')"></p>
            </div>
        </overlay>

        <overlay id="data-package-diag" :image="'bus-warbe-diag'" :satelite="'satelite-diag'" v-if="showDiag" @close="closeDiag">
            <div slot="content">
                <h3>{{ $t('signalstore.modal_diag_header') }}</h3>
                <p>
                    {{ $t('signalstore.modal_diag_copy_1') }}
                </p>
            </div>

            <div slot="info">
                <p v-html="$t('signalstore.modal_diag_info')"></p>
            </div>
        </overlay>

        <overlay-realtime id="realtime" :image="'bus-warbe-realtime'" :satelite="'satelite-realtime'" v-if="showRealtime" @close="closeRealtime">
            <div slot="content">
                <h3 v-html="$t('signalstore.modal_realtime_header')"></h3>
                <h4 v-html="$t('signalstore.modal_realtime_subheader_1')" style="text-align: left; font-family: Demi; font-size: 20px; line-height: 32px; color: #043171"></h4>
                <p v-html="$t('signalstore.modal_realtime_copy_1')">
                </p>
                <h4 v-html="$t('signalstore.modal_realtime_subheader_2')" style="text-align: left; font-family: Demi; font-size: 20px; line-height: 32px; color: #043171"></h4>
                <p v-html="$t('signalstore.modal_realtime_copy_2')">
                </p>
            </div>

            <div slot="info">
                <p v-html="$t('signalstore.modal_realtime_info')"></p>
            </div>
        </overlay-realtime>
    </div>
</template>

<script>
import Sidebar from './Sidebar.vue';
import Overlay from '../components/Overlay.vue';
import OverlayRealtime from '../components/OverlayRealtime.vue';

export default {
    components: {
        'sidebar': Sidebar,
        'overlay': Overlay,
        'overlay-realtime': OverlayRealtime,
    },

    data() {
        return {
            showRfms: false,
            showPlus: false,
            showDiag: false,
            showRealtime: false,
        }
    },

    methods: {
        imagePath: function (fileName) {
            if(fileName != '')
                return require('../assets/icons/' + fileName + '.svg')
        },

        closeRfms: function() {
            this.showRfms = false;
        },

        closePlus: function() {
            this.showPlus = false;
        },

        closeDiag: function() {
            this.showDiag = false;
        },

        closeRealtime: function() {
            this.showRealtime = false;
        }
    },
    
    mounted() {
        this.$root.headline = '';
        this.$root.subheadline = '';
    }
}
</script>


<style scoped>
.signal-container {
    width: calc(100% - 500px);
    margin-left: auto;
    margin-right: auto;
    margin-top: 81px;
    padding-left: 500px;
}

.signal-container .content-wrapper {
    padding-top: 28px;
    padding-left: 47px;
    padding-right: 58px;
    padding-bottom: 13px;
    width: 1261px;
    height: 560px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 25px 31px 53px #1516221A;
    border-radius: 23px 23px 14px 14px;
    backdrop-filter: blur(12px);
    font-family: Demi;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: 0.2px;
}

.signal-container .content-wrapper > div {
    height: 100%;
    align-items: center;
}

.signal-container .content-wrapper .info-wrapper {
    display: flex;
    flex-direction: row;
    margin-bottom: 100px;
}

.signal-container .content-wrapper .info-wrapper p {
    text-align: left;
    font-family: Regular;
    font-size: 20px;
    line-height: 27px;
    letter-spacing: 0;
    color: #707070;
}

.signal-container .content-wrapper .info-wrapper img {
    margin-top: -20px;
}

.rest-container {
    margin-right:35px; 
    cursor: pointer;
}

.rest-figure {
    margin-top: 40px; 
    margin-bottom: 40px;
}

/*.signal-container h3 {
    text-align: left;
    width: 756px;
    font-family: CorpBold;
    font-size: 42px;
    line-height: 53px;
    letter-spacing: 1.76px;
    color: #000000;
    margin-bottom: 30px;
}*/

.figure-wrapper {
    border: 4px solid #000;
    border-radius: 5px; 
    padding-left: 15px; 
    padding-right: 15px; 
    margin-bottom: 15px;
}

figure {
    position: relative;
}

figure .bus {
    max-width: 120px;
}

figure .bus2 {
    position: absolute;
    right: 10px;
    top: -13px;
    height: 40px;
}

.flex {
    display: flex;
    justify-content: center;
    align-items: center;
}

.flex-row {
    flex-direction: row;
}

.flex-col {
    flex-direction: column;
}

.arrow {
    margin-right: 35px;
}

@media only screen and (max-device-width: 1024px) {
    .signal-container {
        width: calc(100% - 260px);
        margin-left: auto;
        margin-right: auto;
        margin-top: 81px;
        padding-left: 260px;
    }

    .signal-container .content-wrapper {
        padding-top: 13px;
        padding-left: 30px;
        padding-right: 30px;
        padding-bottom: 13px;
        width: 90%;
        height: 100%;
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 25px 31px 53px #1516221A;
        border-radius: 23px 23px 14px 14px;
        backdrop-filter: blur(12px);
        font-family: Demi;
        font-size: 12px;
        line-height: 20px;
        letter-spacing: .2px;
    }

    .signal-container .content-wrapper > div {
        height: 100%;
        align-items: center;
    }

    .signal-container .content-wrapper .info-wrapper {
        display: flex;
        flex-direction: row;
        margin-bottom: 100px;
    }

    .signal-container .content-wrapper .info-wrapper p {
        text-align: left;
        font-family: Regular;
        font-size: 20px;
        line-height: 27px;
        letter-spacing: 0;
        color: #707070;
    }

    .signal-container .content-wrapper .info-wrapper img {
        margin-top: -20px;
    }

    .rest-figure {
        margin-top: 20px; 
        margin-bottom: 20px;
    }

    .rest-container {
        margin-right: 15px;
    }

    /*.signal-container h3 {
        text-align: left;
        width: 756px;
        font-family: CorpBold;
        font-size: 42px;
        line-height: 53px;
        letter-spacing: 1.76px;
        color: #000000;
        margin-bottom: 30px;
    }*/

    .figure-wrapper {
        border: 4px solid #000;
        border-radius: 5px; 
        padding-left: 5px; 
        padding-right: 5px; 
        margin-bottom: 15px;
    }

    figure img {
        max-width: 60px;
    }

    figure .bus2 {
        position: absolute;
        right: 10px;
        top: -13px;
        height: 23px;
    }

    .flex {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .flex-row {
        flex-direction: row;
    }

    .flex-col {
        flex-direction: column;
    }

    .arrow {
        margin-right: 10px;
    }

    .arrow.single img {
        width: 45px;
    }

    .arrow.group img {
        width: 60px;
    }
}

@media only screen and (max-device-width: 1366px) {
    .signal-container {
        width: calc(100% - 260px);
        margin-left: auto;
        margin-right: auto;
        margin-top: 81px;
        padding-left: 260px;
    }

    .signal-container .content-wrapper {
        padding-top: 13px;
        padding-left: 30px;
        padding-right: 30px;
        padding-bottom: 13px;
        width: 90%;
        height: 100%;
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 25px 31px 53px #1516221A;
        border-radius: 23px 23px 14px 14px;
        backdrop-filter: blur(12px);
        font-family: Demi;
        font-size: 12px;
        line-height: 20px;
        letter-spacing: .2px;
    }

    .signal-container .content-wrapper > div {
        height: 100%;
        align-items: center;
    }

    .signal-container .content-wrapper .info-wrapper {
        display: flex;
        flex-direction: row;
        margin-bottom: 100px;
    }

    .signal-container .content-wrapper .info-wrapper p {
        text-align: left;
        font-family: Regular;
        font-size: 20px;
        line-height: 27px;
        letter-spacing: 0;
        color: #707070;
    }

    .signal-container .content-wrapper .info-wrapper img {
        margin-top: -20px;
    }

    .rest-figure {
        margin-top: 20px; 
        margin-bottom: 20px;
    }

    .rest-container {
        margin-right: 15px;
    }

    .rest-container > .figure-wrapper {
        min-height: 350px;
        display: flex;
        justify-content: space-evenly;
        flex-direction: column;
    }

    /*.signal-container h3 {
        text-align: left;
        width: 756px;
        font-family: CorpBold;
        font-size: 42px;
        line-height: 53px;
        letter-spacing: 1.76px;
        color: #000000;
        margin-bottom: 30px;
    }*/

    .figure-wrapper {
        border: 4px solid #000;
        border-radius: 5px; 
        padding-left: 5px; 
        padding-right: 5px; 
        margin-bottom: 15px;
    }

    figure img {
        max-width: 60px;
    }

    figure .bus2 {
        position: absolute;
        right: 10px;
        top: -13px;
        height: 23px;
    }

    .flex {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .flex-row {
        flex-direction: row;
    }

    .flex-col {
        flex-direction: column;
    }

    .arrow {
        margin-right: 10px;
    }

    .arrow.single img {
        width: 45px;
    }

    .arrow.group img {
        width: 60px;
    }
}

</style>